var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PopUp",on:{"click":_vm.close}},[_c('div',{staticClass:"img-wrap"},[_c('div',{staticClass:"img-content"},[_c('img',{attrs:{"src":_vm.link},on:{"click":_vm.stop}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }